import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function LaravelDevelopmentServicesProvide() {
    const features = [
        {
            title: 'Customized Laravel Development Services',
            description:
                'Our Laravel experts develop business-ready web and mobile applications by customizing the MVC architecture. We analyze your business model thoroughly to create custom Laravel solutions that meet your changing business needs.',
            icon: '/img/technology/ic-customized-laravel-development.svg',
        },
        {
            title: 'Laravel Enterprise Solutions',
            description:
                'By using the latest Laravel tools, we develop custom Laravel enterprise solutions on a scalable architecture to simplify the complex business ecosystem. We create robust applications with maximum functionality for our enterprise-level clients across industries.',
            icon: '/img/technology/ic-enterprise-solution.svg',
        },
        {
            title: 'Laravel Data Migration Solutions',
            description:
                'We can upgrade your existing Laravel application or migrate from one Laravel platform to another effortlessly. With our assistance, you can accomplish the migration without losing any data and take advantage of all the latest features available in Laravel 9.0.',
            icon: '/img/technology/ic-data-migration.svg',
        },
        {
            title: 'Laravel Ecommerce Development Solutions',
            description:
                "Our Laravel developers can create cutting-edge eCommerce stores to help you reach your global target market with minimal investment. We build eCommerce solutions using the Laravel PHP framework to provide your enterprise with highly customizable features.",
            icon: '/img/technology/ic-ecommerce-development.svg',
        },
        {
            title: 'Laravel Extension Development',
            description:
                'We develop a variety of high-end extensions based on the Laravel framework to deliver fully functional apps with great UI and simple navigation. Our Laravel experts can create powerful Laravel extensions to meet your business needs.',
            icon: '/img/technology/ic-extension-development.svg',
        },
        {
            title: 'Laravel CRM Development',
            description:
                'With the help of our skilled Laravel developers, design a dynamic CRM system to manage multiple business activities and gain a competitive edge. To improve your business operations, we can create basic to advanced CRM apps from scratch.',
            icon: '/img/technology/ic-crm-development.svg',
        },
        
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
